export default __webpack_public_path__ + "static/media/LAS0860.34I-39520_-23418_0.e9cbf82f.jpg";